<!--
 * @Author: 汪俊洪
 * @Date: 2021-07-15 15:30:48
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-09-02 10:34:20
 * @Description: 上传文件
-->
<template>
  <el-upload
    class="upload-demo"
    :action="action"
    :limit="limit"
    :on-exceed="handleExceed"
    :before-upload="beforeUploadEvent"
    :on-success="onSuccess"
    :on-remove="handleRemove"
    :on-error="onError"
    :file-list="list"
    :accept="accept"
    :show-file-list="showFileList"
  >
    <el-button size="small" type="primary">{{ buttonText }}</el-button>
    <div v-if="tip" slot="tip" class="el-upload__tip">
      {{ tip }}
    </div>
  </el-upload>
</template>

<script>
export default {
  props: {
    limit: {
      // 能传几条数据
      type: Number,
      default: 1
    },
    fileList: {
      // 默认显示的数据
      type: Array,
      default: function () {
        return []
      }
    },
    // 提示文字
    tip: {
      type: String,
      default: ''
    },
    // 限制上传类型
    accept: {
      type: String,
      default: ''
    },
    // 上传前的校验
    beforeUpload: {
      type: Function,
      default: null
    },
    // 按钮文案
    buttonText: {
      type: String,
      default: '点击上传'
    },
    showFileList: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      action: window.SITE_CONFIG.apiURL + '/front/fileupload/alioss/upload', // 上传地址
      list: []
    }
  },
  methods: {
    // 文件超过限制提示
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    // 上传前校验
    beforeUploadEvent (file) {
      if (!this.beforeUpload) {
        return true
      }
      return this.beforeUpload(file)
    },
    setData (fileList) {
      const arr = fileList.map((item) => {
        // 需要判断是回显的还是新上传的
        if (
          item.response &&
          item.response.data &&
          item.response.data.aliOssId
        ) {
          return item.response.data.aliOssId
        }
        // 返回回显的
        return item.aliOssId
      })
      return arr
    },
    // 成功的回调
    onSuccess (res, file, fileList) {
      if (res.code === 0) {
        // 参数返回给父组件
        this.$emit('onSuccess', res.data)
      } else {
        fileList.pop()
        this.$message.error(res.message || '上传失败，请重试')
      }
      this.list = fileList
    },
    // 删除的回调
    handleRemove (file, fileList) {
      this.$emit('onSuccess', this.setData(fileList))
      this.list = fileList
    },
    // 失败的回调
    onError (res) {
      this.$message.error(res.message || '上传失败，请重试')
    },
    // 清空数组
    reset () {
      this.list = []
    }
  }
}
</script>

<style lang="scss" scoped></style>
